import { useMutation, useQueryClient } from '@tanstack/react-query'
import { updateLocationStatusByFilter } from '../../../api/plan-location-override-rules-api'
import type {
  UpdateLocationStatusByFilterQueryDto,
  UpdateLocationStatusByFilterResponseDto,
} from '../../../api/dto/plan-location-override-rules.dto'
import type { PlanLocationOverrideRuleStatus } from '../enums/plan-location-override-rule.enum'
import { LOCATION_OVERRIDE_RULES_QUERY_KEY } from '../pages/ListPlanLocationOverride/hooks/useGetLocationOverrideRules'

interface Variables {
  query: UpdateLocationStatusByFilterQueryDto
  targetStatus: PlanLocationOverrideRuleStatus
}

export function useUpdateLocationStatusByFilter() {
  const queryClient = useQueryClient()

  return useMutation<
    UpdateLocationStatusByFilterResponseDto,
    unknown,
    Variables
  >({
    mutationFn: ({ query, targetStatus }) =>
      updateLocationStatusByFilter(query, { status: targetStatus }),
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [LOCATION_OVERRIDE_RULES_QUERY_KEY],
      })
    },
  })
}
